import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import AdminLayout from './AdminLayout';
import './AdminRoute.css';

/**
 * The single gate for every /admin route: waits for auth to resolve, sends
 * signed-out visitors to the auth screen, and refuses non-admins before any
 * admin chrome or data request happens.
 *
 * Each admin page used to repeat the isAdmin check itself, which is how
 * /admin/challenges ended up relying only on the backend.
 */
const AdminRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="admin-route-loading">
        <LoadingSpinner size="large" message="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  // Rendered without AdminLayout on purpose: a non-admin should not see the
  // admin navigation at all.
  if (!user?.isAdmin) {
    return (
      <div className="admin-route-denied">
        <h1>Access Denied</h1>
        <p>You don't have permission to access this page.</p>
      </div>
    );
  }

  return <AdminLayout>{children}</AdminLayout>;
};

export default AdminRoute;
